"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockMetadataGenerator = exports.DefaultMetadataGenerator = void 0;
const shared_1 = require("@buildwithflux/shared");
const constants_1 = require("./constants");
class DefaultMetadataGenerator {
    codeVersion;
    storageId;
    source;
    environment;
    constructor(codeVersion = shared_1.APP_VERSION, storageId = (0, shared_1.guid)(), source, environment = (0, shared_1.getEnvironmentName)()) {
        this.codeVersion = codeVersion;
        this.storageId = storageId;
        this.source = source;
        this.environment = environment;
    }
    generate(flavor = "subcollection", storageId, managedService) {
        const meta = {
            source: this.source,
            storageId: storageId ?? this.storageId,
            codeVersion: this.codeVersion,
            environment: this.environment,
        };
        if (flavor === "baseDocument") {
            meta.schemaVersion = constants_1.DataModelSchemaVersion;
        }
        if (managedService) {
            const managedMeta = {
                ...meta,
                managedService: managedService.name,
                managedServiceSource: managedService.source,
            };
            return managedMeta;
        }
        return meta;
    }
}
exports.DefaultMetadataGenerator = DefaultMetadataGenerator;
class MockMetadataGenerator extends DefaultMetadataGenerator {
    constructor() {
        super(`mock-${shared_1.APP_VERSION}`, (0, shared_1.guid)(), "server", (0, shared_1.getEnvironmentName)());
    }
}
exports.MockMetadataGenerator = MockMetadataGenerator;
//# sourceMappingURL=metadataGenerator.js.map